import { Injectable, signal, effect } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  // Creamos un signal para almacenar los breadcrumbs
  private breadcrumbsSignal = signal<any[]>([]);

  constructor(private router: Router) {
    // Inicializamos los breadcrumbs inmediatamente en la carga de la aplicación
    this.updateBreadcrumbs(this.router.routerState.snapshot.root);

    // Monitoreamos los cambios de ruta y actualizamos los breadcrumbs cuando se navega
    effect(() => {
      this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(() => {
          this.updateBreadcrumbs(this.router.routerState.snapshot.root);
        });
    });
  }

  // Método para obtener los breadcrumbs
  get breadcrumbs() {
    return this.breadcrumbsSignal.asReadonly();
  }

  // Método para actualizar los breadcrumbs
  private updateBreadcrumbs(route: ActivatedRouteSnapshot, breadcrumbs: any[] = []): void {
    if (route.data['breadcrumb']) {
      breadcrumbs.push({
        label: route.data['breadcrumb'],
        url: '/' + route.routeConfig?.path
      });
    }

    if (route.firstChild) {
      this.updateBreadcrumbs(route.firstChild, breadcrumbs);
    } else {
      this.breadcrumbsSignal.set(breadcrumbs); // Actualizamos el signal con los breadcrumbs
    }
  }
}
